import { Injectable } from '@angular/core';
import { HttpAuthService } from '@core/http/services/auth.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StorageService } from '../services/native/storage.service';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public token: string | null = '';

  constructor(
    private httpAuthService: HttpAuthService,
    private storageService: StorageService
  ) {
    this.loadToken();
  }

  private loadToken() {
    this.token = localStorage.getItem(TOKEN_KEY);

    if (this.token) {
      this.isAuthenticated.next(true);
    }
    else {
      this.isAuthenticated.next(false);
    }
  }

  public login(credentials: { username, password }): Promise<any> {
    return new Promise(
      (resolve, reject) => {
        let subscription: Subscription = this.httpAuthService.login(credentials)
          .subscribe(
            {
              next: responseBody => {
                const user = responseBody.data;
                this.token = user.session_token;

                this.storageService.set(TOKEN_KEY, this.token);
                this.storageService.set(USER_KEY, JSON.stringify(user));

                this.isAuthenticated.next(true);

                resolve(true);
              },
              error: e => reject(e),
              complete: () => subscription.unsubscribe()
            }
          );
      }
    );
  }

  logout(): Promise<void> {
    return new Promise(
      resolve => {
        this.isAuthenticated.next(false);
        this.token = '';
        this.storageService.clear();
        resolve();
      }
    )
  }
}
